import { StyleProps } from 'blaze-ui/StyleProps'
import { CSSProperties } from 'react'

const supportedStyles = ['justifyContent', 'color']

export function useStyleProps<T extends StyleProps>(props: T) {
  let styleProps: CSSProperties = {}

  for (const prop in props) {
    if (supportedStyles.includes(prop)) {
      styleProps = {
        ...styleProps,
        [prop]: props[prop],
      }
    }
  }

  return { styleProps }
}
